<template>
    <div class="graph" :style="`height:${height}; width:${width}`">

        <canvas :id="id" :width="500 * 2" :height="400"></canvas>

    </div>
</template>

<script>
    var perPointOrderPlugin = {
        id: 'perPointOrder',
        beforeDatasetDraw: function(chart, args) {
            var meta = chart.getDatasetMeta(args.index)
            if (meta && meta.type === 'bar') return false
        },
        afterDatasetsDraw: function(chart) {
            var ctx = chart.ctx
            var datasets = chart.data.datasets
            var barItems = []
            for (var i = 0; i < datasets.length; i++) {
                var meta = chart.getDatasetMeta(i)
                if (meta && meta.type === 'bar' && !meta.hidden) {
                    barItems.push({ ds: datasets[i], meta: meta })
                }
            }
            if (!barItems.length) return
            var numPoints = (chart.data.labels || []).length
            for (var pi = 0; pi < numPoints; pi++) {
                var barsAtPoint = []
                for (var bi = 0; bi < barItems.length; bi++) {
                    var el = barItems[bi].meta.data[pi]
                    if (el) barsAtPoint.push({ el: el, value: Number(barItems[bi].ds.data[pi]) || 0 })
                }
                // DESC: plus grande valeur dessinée en premier (derrière), plus petite en dernier (devant)
                barsAtPoint.sort(function(a, b) { return b.value - a.value })
                for (var k = 0; k < barsAtPoint.length; k++) barsAtPoint[k].el.draw(ctx)
            }
        }
    }

    export default {

        props: {
            data: Array,
            labels: Array,
            id:String,
            width : {
                type : String,
                default : 'auto'
            },
            height : {
                type : String,
                default : 'auto'
            },
            primaryColor: {
                type: Array,
                default: function() {
                    return [107, 31, 77];
                }
            },
            perPointOrder: {
                type: Boolean,
                default: false
            },
            stacked: {
                type: Boolean,
                default: false
            }
        },



        data() {
            return {
                chart: null,
                gradiantPrimaryColorHsl : [],
                countDataTypeBar : 0,
                countDataTypeLine : -1
            }
        },

        mounted () {
            this.initGradiantPrimaryColor()
            this.createChart()

        },

        watch: {
            data() {
                this.initGradiantPrimaryColor()
                this.updateChat()
            },

            labels() {
                this.initGradiantPrimaryColor()
                this.updateChat()
            },
        },

        methods: {
            createChart() {
                this.countDataTypeBar = -1
                this.countDataTypeLine = -1
                let datasets = this.data.map(d => ({
                    label: d.label,
                    data: d.data,
                    name: 'clics',
                    type: d.type,
                    yAxisID: `y-axis-${d.type}`,
                    ...this.getOptionElmtDatasets(d)
                }))

                // eslint-disable-next-line no-undef
                this.chart = new Chart(this.id, {
                    plugins: this.perPointOrder ? [perPointOrderPlugin] : [],

                    data : {
                        labels: this.labels,
                        datasets: datasets
                    },
                    options: {
                        maintainAspectRatio: false,
                        stacked: false,
                        scales: {
                            ['y-axis-line'] : {
                                display : this.data.find(d => (d.type == 'line')) ? true : false,
                                grid: {
                                    color: "#F1EDF5", // Couleur de la grille
                                    lineWidth: 1.0, // Modifier l'épaisseur de la grille
                                    display : this.data.find(d => (d.type == 'bar')) ? false : true
                                },
                                ticks: {
                                    font: {
                                        size: 11, // Taille de la police
                                        weight: 'normal', // Poids de la police
                                    },
                                    color: "rgba(18, 24, 38, 0.32)", // Couleur des ticks
                                    // stepSize: 5 // Taille du pas entre chaque tick
                                    beginAtZero: true

                                },
                                border : {
                                    color: "#F1EDF5"
                                },
                                position: this.data.find(d => (d.type == 'bar')) ? 'right' : 'left',
                            },
                            ['y-axis-bar'] : {
                                display : this.data.find(d => (d.type == 'bar')) ? true : false,
                                grid: {
                                    color: "#F1EDF5", // Couleur de la grille
                                    lineWidth: 1.0, // Modifier l'épaisseur de la grille
                                },
                                ticks: {
                                    font: {
                                        size: 11, // Taille de la police
                                        weight: 'normal', // Poids de la police
                                    },
                                    color: "rgba(18, 24, 38, 0.32)", // Couleur des ticks
                                    //// stepSize: 5 // Taille du pas entre chaque tick
                                    //beginAtZero: true
                                },
                                border : {
                                    color: "#F1EDF5"
                                },
                            },
                            x: {
                                grid: {
                                    color: "#F1EDF5", // Couleur de la grille
                                    lineWidth: 1.0 // Modifier l'épaisseur de la grille
                                },
                                ticks: {
                                    font: {
                                        size: 11, // Taille de la police
                                        weight: 'normal', // Poids de la police
                                    },
                                    color: "rgba(18, 24, 38, 0.32)", // Couleur des ticks
                                    // stepSize: 5 // Taille du pas entre chaque tick
                                    beginAtZero: true
                                },
                                border : {
                                    color: "#F1EDF5"
                                },
                                stacked: this.stacked
                            }
                        },

                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                            legend: {
                                display: true,
                                position: "bottom",
                                align: "center",
                                reverse:true,
                                labels: {
                                    color: '#555E75',
                                    strokeStyle : 'transparent',
                                    usePointStyle: true,
                                    padding: 20,
                                },
                            },
                            tooltip: {
                                mode: 'index',
                                intersect: false,
                            }
                        }
                    },

                })
                console.log("createChartt",this.chart )
            },
            updateChat() {
                console.log("updateChat slidegraph")
                this.countDataTypeBar = -1
                this.countDataTypeLine = -1


                let datasets = this.data.map(d => ({
                    label: d.label,
                    data: d.data,
                    name: 'clics',
                    type: d.type,
                    yAxisID: `y-axis-${d.type}`,
                    ...this.getOptionElmtDatasets(d)
                }))


                this.chart.data.datasets = datasets
                this.chart.data.labels = this.labels

                this.chart.options.scales['y-axis-line'] = {
                    display : this.data.find(d => (d.type == 'line')) ? true : false,
                    grid: {
                        color: "#F1EDF5", // Couleur de la grille
                        lineWidth: 1.0, // Modifier l'épaisseur de la grille
                        display : this.data.find(d => (d.type == 'bar')) ? false : true
                    },
                    ticks: {
                        font: {
                            size: 11, // Taille de la police
                            weight: 'normal', // Poids de la police
                        },
                        color: "rgba(18, 24, 38, 0.32)", // Couleur des ticks
                        // stepSize: 5 // Taille du pas entre chaque tick
                        beginAtZero: true

                    },
                    border : {
                        color: "#F1EDF5"
                    },
                    position: this.data.find(d => (d.type == 'bar')) ? 'right' : 'left',
                }

                this.chart.options.scales['y-axis-bar'] = {
                    display : this.data.find(d => (d.type == 'bar')) ? true : false,
                    grid: {
                        color: "#F1EDF5", // Couleur de la grille
                        lineWidth: 1.0, // Modifier l'épaisseur de la grille
                    },
                    ticks: {
                        font: {
                            size: 11, // Taille de la police
                            weight: 'normal', // Poids de la police
                        },
                        color: "rgba(18, 24, 38, 0.32)", // Couleur des ticks
                        // stepSize: 5 // Taille du pas entre chaque tick
                        beginAtZero: true
                    },
                    border : {
                        color: "#F1EDF5"
                    },
                    stacked: this.stacked
                }
                this.chart.options.scales.x = {
                    grid: {
                        color: "#F1EDF5", // Couleur de la grille
                        lineWidth: 1.0 // Modifier l'épaisseur de la grille
                    },
                    ticks: {
                        font: {
                            size: 11, // Taille de la police
                            weight: 'normal', // Poids de la police
                        },
                        color: "rgba(18, 24, 38, 0.32)", // Couleur des ticks
                        // stepSize: 5 // Taille du pas entre chaque projet
                        beginAtZero: true
                    },
                    border : {
                        color: "#F1EDF5"
                    },
                    stacked: this.stacked
                }


                this.chart.update()
                console.log("chart",this.chart)
            },
            getOptionElmtDatasets(data) {
                switch (data.type) {
                    case "line": {
                        this.countDataTypeLine++
                        const LINE_COLORS = ['#6B1F4D', '#B64985', '#3B82F6', '#10B981', '#F59E0B', '#EF4444']
                        return {
                            tension: 0.4,
                            fill: false,
                            borderColor: data.color || LINE_COLORS[this.countDataTypeLine % LINE_COLORS.length],
                            borderWidth: 4,
                            borderRadius: 20,
                            pointRadius: 0,
                            order: 100,
                        }
                    }
                    case "bar": {
                        this.countDataTypeBar++
                        const hslColor = this.gradiantPrimaryColorHsl[this.countDataTypeBar]
                        const bgColor = data.color || (hslColor ? `hsl(${hslColor.map((n, i) => i > 0 ? n + '%' : n).join(',')})` : '#6B1F4D')
                        return {
                            backgroundColor: bgColor,
                            borderWidth: 0,
                            pointRadius: 0,
                            barThickness: 10,
                            order: this.countDataTypeBar + 1,
                        }
                    }
                    default:
                        return {}
                }

            },

            initGradiantPrimaryColor() {
                //itialise une liste de couleur prenant la couleur primaire comme reference,
                //Les couleurs sont de plus en plus claire
                //Nous calculons le nombre de data de type bar afin de favoriser une meilleur variété de couleur
                //ex 4 data type bar, alors 4 couleurs
                //Les dégradé de couleur sert qu'un type bars

                let countDataTypeBar = this.data.filter((d) => d.type == 'bar').length;
                let colorHsl = this.rgbToHsl(this.primaryColor[0], this.primaryColor[1], this.primaryColor[2])

                if (colorHsl[2] + 20*(countDataTypeBar-1) > 90) {
                    colorHsl[2] = 100 - 20*countDataTypeBar
                }

                this.gradiantPrimaryColorHsl = [colorHsl]

                for (let i = 2; i <= countDataTypeBar; i++) {
                    this.gradiantPrimaryColorHsl.push([colorHsl[0],colorHsl[1],this.gradiantPrimaryColorHsl[this.gradiantPrimaryColorHsl.length-1][2] + 10])
                }

            },
            rgbToHsl(r, g, b){
                r /= 255;
                g /= 255;
                b /= 255;
                const l = Math.max(r, g, b);
                const s = l - Math.min(r, g, b);
                const h = s
                    ? l === r
                    ? (g - b) / s
                    : l === g
                    ? 2 + (b - r) / s
                    : 4 + (r - g) / s
                    : 0;
                return [
                    60 * h < 0 ? 60 * h + 360 : 60 * h,
                    100 * (s ? (l <= 0.5 ? s / (2 * l - s) : s / (2 - (2 * l - s))) : 0),
                    (100 * (2 * l - s)) / 2,
                ];
            }
        },
    }
</script>
